<td>
    <label class="drpdwn_period_label" style="width: 100%;">{{periodLabel}}</label>

</td>
<td style="padding-left: 6%;">
    <select [(ngModel)]="selected_period_id" [ngModelOptions]="{standalone: true}"
        style="font-family:Roboto;font-size:13px;" class="drpdwn_period" (change)="onPeriodChange()">
        <option *ngFor="let period of periodData" [value]="period.periodId">
            {{period.period}}
        </option>
    </select>
</td>